import React, { useEffect, useState } from 'react';
import { Button } from '@/components/ui/button';
import { Link } from 'react-router-dom';
import { fetchCarousel } from '@/services/api'; // Ensure this is correctly imported
import axios from 'axios';

interface CarouselItem {
  image: string;
  title: string;
  description: string;
}

const Hero = () => {
  const [carouselItems, setCarouselItems] = useState<CarouselItem[]>([]);
  const [currentSlide, setCurrentSlide] = useState(0);

  useEffect(() => {
    const loadCarousel = async () => {
      try {
        const response = await fetchCarousel();
        const data = response.data.carouselItems;

        // Optional: Filter only those with image/title/description
        const validItems = data.filter(
          (item: any) => item.image && item.title && item.description
        );

        setCarouselItems(validItems);
      } catch (error) {
        console.error('Failed to load carousel items:', error);
      }
    };

    loadCarousel();
  }, []);

  const [siteIcon, setSiteIcon] = useState<string | null>(null);

  useEffect(() => {
    const fetchSiteIcon = async () => {
      try {
        const response = await axios.get('https://api.ibadansouthanglicandiocese.org.ng/api/v1/site_icon');
        setSiteIcon(response.data); // assuming it's just a URL string
      } catch (error) {
        console.error('Failed to fetch site icon', error);
      }
    };

    fetchSiteIcon();
  }, []);

  useEffect(() => {
    if (carouselItems.length === 0) return;
    const interval = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % carouselItems.length);
    }, 10000);
    return () => clearInterval(interval);
  }, [carouselItems]);

  const current = carouselItems[currentSlide];

  return (
    <div className="relative bg-gradient-to-r from-purple-600 via-purple-800 to-purple-700 text-white overflow-hidden">
      <div className="absolute inset-0 bg-black opacity-30"></div>

      {/* Background image from fetched slide */}
      {current?.image && (
        <div
          className="absolute inset-0 bg-cover bg-center bg-no-repeat opacity-20 transition-all duration-1000"
          style={{
            backgroundImage: `url('${current.image.startsWith('http')
              ? current.image
              : `https://api.ibadansouthanglicandiocese.org.ng/img/${current.image}`
              }')`,
          }}
        />
      )}


      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-24 lg:py-32">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <div className="space-y-8">
            <div>
              <h1 className="text-4xl lg:text-6xl font-bold leading-tight">
                {current?.title || 'Welcome to the Diocese of Ibadan South'}
                {/* <span className="block text-yellow-300"> Diocese of Ibadan South</span> */}
              </h1>
              {/* <p className="text-xl lg:text-2xl text-purple-100 mt-4">
                Anglican Communion
              </p> */}
            </div>

            <p className="text-lg lg:text-xl text-purple-100 leading-relaxed">
              {current?.description || `Building God's kingdom through faith, fellowship, and service.`}
            </p>

            <div className="flex flex-col sm:flex-row gap-4">
              <Button asChild size="lg" className="bg-yellow-500 hover:bg-yellow-600 text-black font-semibold">
                <Link to="/about">Learn About Us</Link>
              </Button>
              <Button asChild variant="outline" size="lg" className="border-white text-purple-400 hover:bg-white hover:text-purple-800">
                <Link to="/events">Upcoming Events</Link>
              </Button>
            </div>
          </div>

          <div className="flex justify-center lg:justify-end">
            <div className="relative">
              <div className="w-64 h-64 lg:w-80 lg:h-80 bg-white bg-opacity-10 backdrop-blur-sm rounded-full border border-white border-opacity-20 flex items-center justify-center">
                <div className="text-center space-y-4">
                  <div className="text-6xl lg:text-7xl">
                    ✝
                  </div>
                  <div className="text-lg font-semibold">The Joy of the Lord, OUR STRENGTH</div>
                </div>
              </div>
              <div className="absolute -top-4 -right-4 w-16 h-16 bg-yellow-400 rounded-full flex items-center justify-center">
                <span className="text-2xl">
                  {siteIcon ? (
                    <img src={siteIcon} alt="Site Icon" className="w-full h-full object-cover" />
                  ) : (
                    <span className="text-white font-bold text-lg bg-purple-700 w-full h-full flex items-center justify-center">🕊</span>
                  )}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom wave decoration */}
      <div className="absolute bottom-0 left-0 right-0">
        <svg className="w-full h-24 text-white" preserveAspectRatio="none" viewBox="0 0 1200 120" fill="currentColor">
          <path d="M0,0V46.29c47.79,22.2,103.59,32.17..." />
        </svg>
      </div>
    </div>
  );
};

export default Hero;
